module.exports = __webpack_public_path__ + "assets/img/IMG051.5248d968.png";